function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "41.06",
  height: "31.729"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2767",
  "data-name": "Path 2767",
  d: "M69.609 7.585l-7.483 7.483-1.55-1.55-1.551-1.55 9.848-9.847L66.752 0 56.9 9.847l-2.121 2.121-3.447 3.452a4.9 4.9 0 00-5.174 4.23 48.476 48.476 0 01-3.093 9.079H30.67v3h13.749v-.07a2.04 2.04 0 00.407.049h.112c2.048-.113 7.167-.727 10.452-4.011 1.141-1.141 2.717-2.723 3.042-4.69l3.694-3.694 2.121-2.121 7.483-7.486zm-16.34 17.988a12.324 12.324 0 01-6.863 2.974 46.885 46.885 0 002.7-8.329 2.06 2.06 0 011.341-1.718 2.038 2.038 0 01.6-.087 4.832 4.832 0 013.154 1.65c2.064 2.064 1.636 2.942-.936 5.514m4.522-6.17l-3.1-3.1L56.9 14.09l1.551 1.549 1.55 1.55z",
  transform: "translate(-30.67)",
  fill: "#fff"
})));